module.exports = __webpack_public_path__ + "img/countedServiceTypes.20be7e6e.svg";